import { lazy } from 'react';
import { createBrowserRouter, Navigate, useLocation } from 'react-router-dom';

import Layout from '../pages/components/Layout';

// Lazy load components for code splitting
const ProjectList = lazy(() => import('../pages/ProjectsList'));
const NotFound = lazy(() => import('../pages/NotFound'));
const NewProject = lazy(() => import('../pages/NewProject'));
const ProjectDetail = lazy(() => import('../pages/ProjectDetail'));
const ArtifactsList = lazy(() => import('../pages/ArtifactsList'));
const ArtifactDetail = lazy(() => import('../pages/ArtifactDetail'));
const PdfViewer = lazy(() => import('../pages/pdfViewer'));
const RootRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`projects${search}`} replace />;
};

const routes = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        // redirect root '/' to the relative child path 'my-projects' keeping params
        element: <RootRedirect />,
      },
      {
        path: "projects",
        element: <ProjectList />,
        children: [
          {
            path: "detail",
            element: <ProjectDetail />,
            children: [
              {
                path: "pdf-view",
                element: <PdfViewer />,
              },
            ],
          }
        ],
      },
      {
        path: "projects/new",
        element: <NewProject />,
      },
      {
        path: "artifacts",
        element: <ArtifactsList />,
        children: [
          {
            path: "detail",
            element: <ArtifactDetail />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFound />,
        label: 'Not Found',
      },
    ],
  },
];

const router = createBrowserRouter(routes);
export default router;